module.exports = __webpack_public_path__ + "img/9788952757159.13c34847.jpg";